// extracted by mini-css-extract-plugin
module.exports = {"container":"Filter_container__22XaB","main":"Filter_main__1YALU","title":"Filter_title__v2w9a","filter":"Filter_filter__2buE9"};